import { Map } from 'immutable';
import atomicBlock from '@studionand/ada-next/src/legacy/atomicBlock';
import Ansprechpartner from './component';

const ASBlock = atomicBlock({ alignment: false })(Ansprechpartner);

const plugin = () => ({
  blockRendererFn: (block, { getProps }) => {
    const type = block.getType();
    const { page } = getProps();
    if (type === 'ansprechpartner') {
      return {
        component: ASBlock,
        editable: false,
        props: {
          pageUuid: page.uuid,
        },
      };
    }
    return null;
  },
  blockStyleFn: (block) => { // eslint-disable-line
    const type = block.getType();
    // if (type === 'ansprechpartner') return style.ansprechpartnerWrap;
    return null;
  },
  blockRenderMap: Map({
    ansprechpartner: {
      element: 'div',
      isBlockTypeMutable: false,
      fixed: false,
    },
  }),
});

export default plugin;
